<template>
  <div>
    <setUserTable />
    <div class="wrap">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="配置" name="first">
          <option-list />
        </el-tab-pane>
        <el-tab-pane label="监控记录" name="second">
          <record-list />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import optionList from './components/option';
import recordList from './components/record';
import setUserTable from '../components/setUserTable';
export default {
  name: 'SensitiveWords',
  components: { optionList, recordList, setUserTable },
  props: {},
  data() {
    return {
      activeName: 'first',
    };
  },
  computed: {},
  created() {
    // 设置面包屑
    const breadcrumb = [
      { menu_name: '企业微信管理管理', menu_path: '', menu_params: {} },
      { menu_name: '会话留存', menu_path: 'chattingRecords', menu_params: {} },
      { menu_name: '敏感词', menu_params: { componentName: 'sensitiveWords' } },
    ];
    this.g_breadcrumb(breadcrumb);
  },
  methods: {},
};
</script>
<style lang="scss" scoped></style>
